import { effect, inject, Injectable, signal } from '@angular/core';
import { CompanyContext } from '@models/webapi/user-profile';
import { LocalStorageService } from '@services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyContextService {
  public readonly currentCompany = signal<CompanyContext | null>(null);

  readonly #localStorage = inject(LocalStorageService);

  constructor() {
    effect(() => {
      const currentCompany = this.currentCompany();
      const sessionStorageCompany = this.#sessionStorageCompany;

      if (currentCompany !== null && currentCompany !== sessionStorageCompany) {
        this.#localStorage.setItem('currentCompany', JSON.stringify(currentCompany));
      }
    });

    this.currentCompany.set(this.#sessionStorageCompany);
  }

  get #sessionStorageCompany() {
    return this.#localStorage.getItem<CompanyContext>('currentCompany');
  }

  public clear() {
    return this.#localStorage.removeItem('currentCompany');
  }
}
